<button
	[type]="buttonType"
	[attr.aria-label]="doNotTranslate ? getAriaLabel() : (getAriaLabel() | translate : buttonTranslateParams)"
	[ngClass]="showAsPlainText ? 'button flat' : buttonCSS ?? 'sm'"
	[title]="doNotTranslate ? title : (title | translate : buttonTranslateParams)"
	[disabled]="disabled || showLoadingSpin"
	(click)="clicked.emit(true)"
>
	<ng-container *ngIf="!showLoadingSpin">
		<i *ngIf="iconCSS" class="ico" [ngClass]="iconCSS"></i>
		<ng-container *ngIf="!isIconOnly">
			<span *ngIf="doNotTranslate">{{ title }}</span>
			<span *ngIf="!doNotTranslate" [translate]="title" [translateParams]="buttonTranslateParams"></span>
		</ng-container>
	</ng-container>
	<ng-container *ngIf="showLoadingSpin">
		<stages-spin size="s" />
	</ng-container>
</button>
